/**
 * Генерация случайной строки
 * Первый символ, не должен быть числом
 * @return {String}
 */
module.exports = function randomString() {
    let rand = Math.random().toString(36).substr(2);
    return rand.replace(/^[0-9]/, (Number(rand[0]) + 10).toString(36));
};
